import { Page } from './pages.d';

const page: Page = {
  slug: 'wachtwoord-aangevraagd',
  title: 'Nieuw wachtwoord aangevraagd',
  text: `
    <p>
      In je mailbox zul je binnen enkele ogenblikken een e-mail ontvangen om een nieuw wachtwoord
      in te stellen.
    </p>

    <p>
      Mocht de mail over vijf minuten nog niet zijn binnengekomen, controleer dan ook even de spam map.
      Als die daar ook niet binnenkomt, neem dan even contact op. Dit kan telefonisch
      (<a href="tel:0341561341">0341 - 561 341</a>) of via de mail <a href="mailto:info@orangetalent.nl">
      info@orangetalent.nl</a>.
    </p>

    <a href="/login" class="btn btn-primary mt-3">
      Terug naar inloggen
    </a>
  `,
};

export default page;
